import React, { useEffect, useState } from "react";
import { classNotMarked } from "../../../../Api/apiUtils";
import { Table, EmptyState } from "../../../../ui";
import "./notMarkClass.scss";

interface ClassData {
  studentId: string;
  courseName: string;
  studentSlotStartTime: string;
  studentSlotEndTime: string;
  teacherSlotStartTime: any;
  teacherSlotDate: any;
  studentName: any;
}

interface ClassProps {
  credentialId?: string; // Optional prop
}

const NotMarkClass: React.FC<ClassProps> = ({ }) => {
  const [classData, setClassData] = useState<ClassData[] | null>(null);
  const storedTeacherId = localStorage.getItem("teacherProfileUserId");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await classNotMarked(storedTeacherId);
        setClassData(response);
      } catch (error) {
        console.error("Error fetching classNotMarked:", error);
        setClassData([]); // Set to empty array on error
      }
    };

    fetchData();
  }, [storedTeacherId]);

  console.log("✅ NotMarkClass Component Rendered!");

  return (
    <div className="tp-notmarked">
      {classData && classData.length > 0 ? (
        <Table caption="Classes not marked">
          <thead>
            <tr>
              <th scope="col">Student Name</th>
              <th scope="col">Course Name</th>
              <th scope="col">Class Date & Time</th>
            </tr>
          </thead>
          <tbody>
            {classData.map((data: ClassData) => (
              <tr key={data.studentId}>
                <td>{data.studentName}</td>
                <td>{data.courseName}</td>
                <td> {data.teacherSlotDate} / {data.studentSlotStartTime} </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <EmptyState title="No data available" />
      )}
    </div>
  );
};

export default NotMarkClass;